import { createJobManager } from './manager';
import { JobManager } from './_types';

const jobManagerInstance: JobManager = createJobManager();

export default jobManagerInstance;
